module.exports = __webpack_public_path__ + "01dbce3856d791b8b01c27d236f18341.jpg";